// extracted by mini-css-extract-plugin
module.exports = {"container":"_rFB1oNASC9BfSxAxiFck","image":"_2DOY7ANGCry39xPoYzoBVQ","link":"_2PQRppHTUNmAgvGgZbuPIX","title":"_1-ukqCIm40o57JU7iTxcfd","description":"_A6j5bjrpGUCLE9mlBfzl"};